import api from "api";

export const vayuLead = (page, query) => {
  return api.get(`vayu/leads?pageNumber=${page}&pageSize=10${query}`);
};

export const vayuCall = (payload) => {
    return api.post(`vayu/call`, payload);
};
